const searchResult = document.querySelector('.search-result');

const input = document.getElementById('surname');

if(input) {
    input.oninput = () => {
        if(input.value.charAt(0) === ' ') {
            input.value = '';
        }
    }
}

function keyFetch (el) {
    const object = {};
    el.forEach((value, key) => {
        // Reflect.has in favor of: object.hasOwnProperty(key)
        if(!Reflect.has(object, key)){
            object[key] = value;
            return;
        }
        if(!Array.isArray(object[key])){
            object[key] = [object[key]];
        }
        object[key].push(value);
    });
    return JSON.stringify(object);
}

let items_data = null;

const addCaption = () => {
    const searchCaption = searchResult.querySelector('.search-caption');
    if(!searchCaption) {
        return  searchResult.insertAdjacentHTML('afterbegin',
            `<h2 class="search-caption">Результаты поиска</h2>`
        )
    }
    return null;
}

function deleteItem ()  {
    const body = searchResult.querySelector('.search');
    const test = body.querySelectorAll('.search__item');
    if(test) {
        test.forEach(el => el.remove());
    }
}


function deletePagination () {
    const deletePagination = document.querySelectorAll('.tui-page-btn');
    if(deletePagination) {
        deletePagination.forEach(el => el.remove());
    }
}

const noResult = () => {
    const body = searchResult.querySelector('.search');
    return  body.insertAdjacentHTML('afterbegin',
        `<div class="server-error">Нет результатов, попробуйте изменить критерии поиска</div>`
    )
}


const ServerError = () => {
    const body = searchResult.querySelector('.search');
    const serverError = body.querySelector('.server-error');
    if (serverError) {
        return  null;
    }
    return  body.insertAdjacentHTML('afterbegin',
        `<div class="server-error">Сервер временно недоступен, попробуйте повторить поиск позже или обновите страницу.</div>`
    )
}

const ServerErrorDelete = () => {
    const body = searchResult.querySelector('.search');
    const serverError = body.querySelector('.server-error');
    if (serverError) {
        return  serverError.remove();
    }
    return null;
}

const addSkeleton = () => {
    const body = searchResult.querySelector('.search');
            body.insertAdjacentHTML('afterbegin',
            `<div class="loader">
                    </div>`
        )
}

const deleteSkeleton = () => {
    const body = searchResult.querySelector('.search');
    const deletekeleton = body.querySelector('.loader');
    if (deletekeleton) {
        deletekeleton.remove();
    }
    return null;
}

const getItemsData = async (curentPage) => {
    let formData = new FormData(formElem);
    formData.append('page', curentPage);

    await fetch(`/`, {
        method: 'POST',
        body: keyFetch(formData),
    }).then(function (response) {
        if(response.status === 200) {
            ServerErrorDelete();
            return response.json()
        }
    }).then(function (data) {
        deleteSkeleton();
        items_data = [data.results, data.nb_rows];
    }).catch(function (error) {
        ServerError();
        deleteItem();
        console.log('error', error)
    })

    return items_data
}

function addItems (data) {
    const body = searchResult.querySelector('.search');
    const searchItem = body.querySelector('.search__info-item');
    if(searchItem) {
        body.innerHTML = '';
        searchCaption.remove();
    }
    data.map((el) => {
        const sectionName = el.section_name ? el.section_name : 'Неизвестно';
        const sectionCity = el.name_ru ? el.name_ru : 'Неизвестно';
        const sectionCem = el.cem_name ? el.cem_name : 'Неизвестно';
        const sectionDateStart = el.date_start ? el.date_start : 'Неизвестно';
        const sectionDateEnd = el.date_end ? el.date_end : 'Неизвестно';
        const sectionPreview = el.preview ? el.preview : '/static/img/no-images.jpg';
        const sectionPreviewFancybox = el.preview ? el.gallery : '/static/img/no-images.jpg'

        if (body) {
            return (
                body.insertAdjacentHTML('afterbegin',
                    `<div class="search__item">
                        <div class="search__img-block">
                            <a data-fancybox="${el.id}" href="${sectionPreviewFancybox}">
                                <img class="search__img" loading="lazy" src="${sectionPreview}" alt="">
                            </a>     
                        </div>
                        <div class="search__info">
                            <a href="/permission-view/${el.id}" target="_blank" class="search__name">${el.last} ${el.first} ${el.middle}</a>
                            <div class="search__info-item"><b>Годы жизни:</b> ${sectionDateStart} — ${sectionDateEnd}</div>
                            <div class="search__info-item"><b>Город:</b> ${sectionCity}</div>
                            <div class="search__info-item"><b>Кладбище:</b> ${sectionCem}</div>
                            <div class="search__info-item"><b>Сектор:</b> ${sectionName}</div>
                            <a class="search__link btn" href="/permission-view/${el.id}" target="_blank">Страница захоронения</a> 
                        </div>
                        <div class="search__maps">
                            <a href="https://yandex.ru/maps/" target="_blank">
                                <img class="search__maps-img" class="" src="https://static-maps.yandex.ru/1.x/?ll=${el.lng},${el.lat}&amp;z=18&amp;l=map&amp;pt=${el.lng},${el.lat}&amp;size=300,300"></a>
                        </div>
                    </div>`
                )
            );
        }
    });
}

const fetchItems = async () => {
    const formElem = document.querySelector('#formElem');
    if(formElem) {
        formElem.onsubmit = async (e) => {
            e.preventDefault();
            deleteItem();
            addCaption();
            addSkeleton();
            let data = await getItemsData(1)
            if(data[0].length === 0) {
                noResult();
            }
            if(data[0].length < 10) {
                deletePagination();
            }
            if(data[0].length === 10) {
                const pagination = new tui.Pagination('pagination', {
                    totalItems: data[1]
                });
                pagination.on('beforeMove', function(eventData) {
                    data = getItemsData(eventData.page);
                    deleteItem();
                    addSkeleton();
                    const body = document.querySelector('#search');
                    body.scrollIntoView({
                        behavior: 'smooth',
                        block: 'start'
                    });
                    data.then(
                        function (data) {
                            addItems(data[0].reverse());
                        }
                    );

                });
            }
            deleteItem();
            addItems(data[0].reverse());
        }
    }
}

const swapValue = () => {
    const value = document.querySelector('optgroup option[value="26"]');
    if(value) {
        value.text="Горнощитское(Мусульманское)"
    }
}
swapValue();
fetchItems();
